export const convertToDate = (date) => {
    const inputDate = new Date(date);
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    };
    const formattedDate = inputDate.toLocaleString("en-US", options);
    return formattedDate;
  };

  export const getMonthAndDate = (reqStartDate, reqEndDate) => {
    if (
      reqStartDate &&
      reqEndDate &&
      reqStartDate.getDate() === new Date().getDate() &&
      reqEndDate.getDate() === new Date().getDate()
    ) {
      return "Today";
    } else if (reqStartDate && reqEndDate) {
      return reqStartDate.getDate() === reqEndDate.getDate()
        ? reqStartDate.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          })
        : reqStartDate.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          }) +
          " to " +
          reqEndDate.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          });
    } else {
      return "Invalid dates selected";
    }
  };
 